export default '/r/@slug'
